import React, {Component} from 'react';

import AuthForm from "./Form/form";

class AuthPage extends Component {
    render() {
        return (
            <AuthForm/>
        );
    }
}

export default AuthPage;
